import { useEffect, useState } from 'react'

import { fetchWeather, type Weather } from '@/lib/weather'

// Riyadh's temperature moves slowly and the endpoint updates every 15 minutes,
// so anything tighter than this is traffic for nothing.
const REFRESH_MS = 10 * 60 * 1000

export function useWeather(): { weather: Weather | null; failed: boolean } {
  const [weather, setWeather] = useState<Weather | null>(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    const controller = new AbortController()

    const load = async () => {
      try {
        setWeather(await fetchWeather(controller.signal))
        setFailed(false)
      } catch (error) {
        if (controller.signal.aborted) return
        // Keep the last good reading on screen; a stale temperature beats the
        // pill emptying out because one poll timed out.
        setFailed(true)
        console.warn('[weather] fetch failed', error)
      }
    }

    void load()
    const timer = window.setInterval(load, REFRESH_MS)
    return () => {
      controller.abort()
      window.clearInterval(timer)
    }
  }, [])

  return { weather, failed }
}
